import { useAction } from '@hooks';
import { useCallback } from 'react';
import { coreActions, UpdateSonarObjectReferenceRequest } from '@sonar-software/sonar-core';

export function useUpdateSonarObjectReference() {
	const updateAction = useAction(coreActions.updateSonarObjectReferences);
	const updateAllAction = useAction(coreActions.updateAllSonarObjectReferences);

	const update = useCallback(
		(request: UpdateSonarObjectReferenceRequest | Array<UpdateSonarObjectReferenceRequest>) => {
			updateAction(Array.isArray(request) ? request : [ request ]);
		},
		[ updateAction ]
	);

	return {
		update,
		updateAll: updateAllAction
	};
}
